import React from 'react'
import up from '../img/up.png'
import down from '../img/down.png'
import none from '../img/all.png'


// добавить в проект иконки и импортировать
const downIcon = up
const upIcon = down
const noneIcon = none

export type SuperSortPropsType = {
    id?: string
    sort: string
    value: string
    onChange: (newSort: string) => void
}

export const pureChange = (sort: string, down: string, up: string) => {
    console.log(sort, down)
    // пишет студент, sort: (click) => down (click) => up (click) => '' (click) => down ...
    if (sort === down) return up
    if (sort === up) return ''
    return down
}

const SuperSort: React.FC<SuperSortPropsType> = (
    {
        sort, value, onChange, id = 'hw15',
    }
) => {
    const up = '0' + value
    const down = '1' + value

    const onChangeCallback = () => {
        onChange(pureChange(sort, down, up))
    }

    const icon = sort === down
        ? downIcon
        : sort === up
            ? upIcon
            : noneIcon

    return (
        <span
            id={id + '-sort-' + value}
            onClick={onChangeCallback}

        >
            {/*сделать иконку*/}

            <img
                id={id + '-icon-' + sort}
                src={icon}
                style={{marginLeft:"10px"}}
            />

            {/*{icon} /!*а это убрать*!/*/}
        </span>
    )
}

export default SuperSort
